module.exports = __webpack_public_path__ + "img/User.f6a4ba1b.svg";